import { useStore as getStore } from "../../utils/useStore.js";
import lightBoxFactory from "./lightBoxFactory.js";

const initialState = () => ({
  fileType: null,
  fileData: null,
  fileId: null,
  isOpen: false,
});

const [LightBoxProvider, useLightBox, withLightBox] = getStore(
  lightBoxFactory,
  initialState,
  "Lightbox"
);

export const lightBoxInitState = initialState();

export { useLightBox, LightBoxProvider, withLightBox };

export default LightBoxProvider;
